export default {
    setRate(currency) {
        window.localStorage.setItem('currency', JSON.stringify(currency));
    },
    getRate() {
        const locaStorageData = window.localStorage.getItem('currency');
        if (!locaStorageData)
            return null;
        return JSON.parse(locaStorageData);
    },
};
